// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__2jovz","backdrop":"Popup_backdrop__KsG8Q"};